import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const ShiftList = () => {
  const navigate = useNavigate();
  const [shifts, setShifts] = useState([]); // default empty array
  const [loading, setLoading] = useState(true);

  const loadShifts = async () => {
    try {
      const res = await axios.get("shifts/");
      // make sure it's an array
      if (Array.isArray(res.data)) {
        setShifts(res.data);
      } else {
        setShifts([]);
      }
    } catch (err) {
      console.error(err);
      setShifts([]); // fallback to empty array
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadShifts();
  }, []);

  if (loading) return <div>Loading shifts...</div>;
  if (shifts.length === 0) return <div>No shifts found.</div>;

  return (
    <div className="card p-3 mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Shifts</h5>
        <button className="btn btn-sm btn-secondary" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </button>
      </div>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Start</th>
            <th>End</th>
            <th>Flexible Start</th>
            <th>Flexible End</th>
            <th>Flexible</th>
            <th>Double</th>
          </tr>
        </thead>
        <tbody>
          {shifts.map((s) => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.start_time || "—"}</td>
              <td>{s.end_time || "—"}</td>
              <td>{s.flex_start || "—"}</td>
              <td>{s.flex_end || "—"}</td>
              <td>{s.is_flexible ? "Yes" : "No"}</td>
              <td>{s.is_double ? "Yes" : "No"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShiftList;
